import React, { FC, MouseEvent } from 'react';
import searchTranslations from 'public/locales/en/search.json';
import { getTranslator } from '../../shared/i18n/getTranslator';
import { DesktopFiltersButton, MobileFiltersButton } from './Filters.styles';
import { FiltersModalProps } from './index';
import { Icon, Text } from '@blueprint/ui';
import { LayoutVersion } from '../../constants';

type FiltersButtonProps = {
    onClick: (evt: MouseEvent<HTMLButtonElement>) => void;
} & Pick<FiltersModalProps, 'version'>;

const t = getTranslator(searchTranslations);
const buttonCopy = t('actionBar.filters');

export const FiltersButton: FC<FiltersButtonProps> = ({ version, onClick }) => {
    switch (version) {
        case LayoutVersion.Desktop:
            return (
                <DesktopFiltersButton
                    variant="secondary"
                    onClick={onClick}
                    data-testid="search-results-header_filters-button"
                >
                    <Icon iconId="filters" />
                    <Text isBold={true}>{buttonCopy}</Text>
                </DesktopFiltersButton>
            );

        case LayoutVersion.Mobile:
            return (
                <MobileFiltersButton
                    variant="secondary"
                    onClick={onClick}
                    data-testid="mobile-sub-header_filters-button"
                >
                    <Icon iconId="filters" />
                    <Text isBold={true}>{buttonCopy}</Text>
                </MobileFiltersButton>
            );
        default:
            return null;
    }
};
